(function () {
  var STOREFRONT_HOSTS = ['alrighty.coffee', 'www.alrighty.coffee', 'alrighty-coffee.myshopify.com'];
  var IS_MYSHOPIFY = window.location.hostname.indexOf('myshopify.com') !== -1;

  function addNoRedirectParams(search) {
    var params = new URLSearchParams(search || '');
    if (!params.has('_fd')) params.set('_fd', '0');
    if (!params.has('pb')) params.set('pb', '0');
    var str = params.toString();
    return str ? '?' + str : '';
  }

  function rewriteHref(a) {
    var raw = a.getAttribute('href');
    if (!raw) return;
    if (raw.charAt(0) === '#') return;
    if (raw.indexOf('mailto:') === 0 || raw.indexOf('tel:') === 0 || raw.indexOf('javascript:') === 0) return;

    var parsed;
    try { parsed = new URL(raw, window.location.origin); } catch (e) { return; }

    var isInternal = parsed.hostname === window.location.hostname || STOREFRONT_HOSTS.indexOf(parsed.hostname) !== -1;
    if (!isInternal) return;

    var pathname = parsed.pathname;
    var search = parsed.search;
    var hash = parsed.hash;

    if (IS_MYSHOPIFY) {
      search = addNoRedirectParams(search);
    }

    var next = pathname + search + hash;
    if (a.getAttribute('href') !== next) {
      a.setAttribute('href', next);
    }
  }

  function rewriteStorefrontLinks(root) {
    var anchors = (root || document).querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      rewriteHref(anchors[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rewriteStorefrontLinks(); });
  } else {
    rewriteStorefrontLinks();
  }

  var linkObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'A') {
          rewriteStorefrontLinks(n.parentNode || document);
        } else if (n.querySelector) {
          rewriteStorefrontLinks(n);
        }
      }
    }
  });
  linkObserver.observe(document.documentElement, { childList: true, subtree: true });

  var BADGE_TEXT = '10% Rabatt';
  var BADGE_CLASS = 'linra-discount-badge';
  var TARGET_SELECTOR = '.rc-radio.subscription-radio, label.subscription-radio, .subscription-radio';

  function stripInlineDiscountText(label) {
    var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.parentElement && n.parentElement.closest('.' + BADGE_CLASS)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue) continue;
      var orig = node.nodeValue;
      var cleaned = orig
        .replace(/\s*10\s*%\s*(rabatt|sparen|off)\s*/gi, ' ')
        .replace(/\s*10\s*%\s*/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (cleaned !== orig) {
        node.nodeValue = cleaned;
      }
    }
  }

  function ensureBadge(label) {
    if (!label) return;
    stripInlineDiscountText(label);
    var existing = label.querySelectorAll('.' + BADGE_CLASS);
    if (existing.length === 0) {
      var badge = document.createElement('span');
      badge.className = BADGE_CLASS;
      badge.textContent = BADGE_TEXT;
      label.appendChild(badge);
      return;
    }
    for (var i = 1; i < existing.length; i++) {
      existing[i].parentNode.removeChild(existing[i]);
    }
    if (existing[0].parentElement !== label) {
      label.appendChild(existing[0]);
    }
  }

  function run() {
    var labels = document.querySelectorAll(TARGET_SELECTOR);
    for (var i = 0; i < labels.length; i++) {
      ensureBadge(labels[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var scheduled = false;
  function scheduleRun() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  var observer = new MutationObserver(scheduleRun);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.rc-widget, .recharge-subscription-widget')) {
      setTimeout(run, 50);
      setTimeout(run, 200);
      setTimeout(run, 500);
    }
  }, true);
})();
